import { Day } from '../constants';

import type {
  AssignedProgram,
  Program,
  ProgramItem,
  WithOptionalId,
  CalendarDaySlot,
} from '../types';

export const getEmptyProgram = (
  name: string,
  level: number,
  fitnessGoal: string,
  isPrivate: boolean,
  trainerId: string,
): WithOptionalId<Program> => ({
  name,
  level,
  isPrivate,
  trainerId,
  fitnessGoal,
  programItems: [[]],
});

export const getDefaultProgram = (
  trainerId: string,
): WithOptionalId<Program> => ({
  name: '',
  isPrivate: true,
  level: 0,
  trainerId,
  fitnessGoal: '',
  programItems: [[]],
});

export const buildSlotsForWeek = (
  weekIndex: number,
  program: WithOptionalId<AssignedProgram>,
  weeksDates: Date[][] | null,
): CalendarDaySlot[] => {
  const weekItems = program.programItems[weekIndex] || [];
  // Use a Map to keep only first workout per day for display (same as previous behavior)
  const itemsMap = new Map<Day, ProgramItem>();
  for (const it of weekItems) {
    const d = it.day as Day | null | undefined;
    if (d && !itemsMap.has(d)) itemsMap.set(d, it);
  }

  const daysOrder = [
    Day.Sunday,
    Day.Monday,
    Day.Tuesday,
    Day.Wednesday,
    Day.Thursday,
    Day.Friday,
    Day.Saturday,
  ];
  const sevenDaysSlots = daysOrder.map((day, idx) => {
    const date = weeksDates ? weeksDates[weekIndex]?.[idx] : undefined;
    const isStartDay =
      Boolean(weeksDates && (program as any).startDate) &&
      date &&
      new Date((program as any).startDate as string).toDateString() ===
        date.toDateString();
    return {
      day,
      item: itemsMap.get(day) ?? null,
      date,
      isStartDay,
    };
  });
  return sevenDaysSlots;
};
